import React from 'react';
import HomeSearchBar from '../../components/HomeSearchBar';
import styles from './Home.style';
import Module from '../../components/Module';
import PageTitle from '../../components/PageTitle';
import ModuleContent from '../../components/ModuleContent';
import Protected from '../../components/Protected';

const Home = () => {
  return (
    <>
      <Module className={styles.root}>
        <HomeSearchBar className={styles.searchBar} />
      </Module>

      <Protected permissions="viewAnalyticsDashboard">
        <Module>
          <PageTitle>Analytics Dashboard</PageTitle>
        </Module>
        <Module className={styles.pbiCanvas}>
          <ModuleContent>
            <div className={styles.iframeContainer}>
              <iframe
                sandbox
                className={styles.iframe}
                src={window.config.powerBIRoyaltiesDashboard}
                frameBorder="0"
                title="Royalties Dashboard PowerBI"
              />
            </div>
          </ModuleContent>
        </Module>
      </Protected>
    </>
  );
};

export default Home;
